import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from '@/pages/home/components/HeroSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import StatsSection from '@/pages/home/components/StatsSection';
import CategoriesSection from '@/pages/home/components/CategoriesSection';
import VideoListSection from '@/pages/home/components/VideoListSection';
import DownloadSection from '@/pages/home/components/DownloadSection';
import FAQSection from '@/pages/home/components/FAQSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: '小蓝视频',
          url: 'https://kbhkgkg.cn',
          description: '轻量高清短视频平台，海量优质内容免费在线观看',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://kbhkgkg.cn/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        })}
      </script>
      <main>
        <Navbar />
        <HeroSection />
        <StatsSection />
        <FeaturesSection />
        <CategoriesSection />
        <VideoListSection />
        <DownloadSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}